'use client';

import { Root, Indicator } from '@radix-ui/react-checkbox';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { FormFieldState } from '@/shared/ui/form/types';
import { Icon } from '@/shared/ui/icon';
import './checkbox.scss';

type Props = ComponentPropsWithRef<typeof Root> & {
    state?: FormFieldState;
};
export const Checkbox = ({ className, state, ...props }: Props) => {
    return (
        <Root data-slot="checkbox" data-form-state={state} className={cn('checkbox', className)} {...props}>
            <Indicator data-slot="checkbox-indicator" className="checkbox__indicator">
                <Icon name="check" />
            </Indicator>
        </Root>
    );
};
